import {SET_CAPTCHA_KEY, SET_CAPTCHA_IMG} from '../store/actionTypes';

export const captchaKey = (state = '', action) => {
    switch (action.type) {
        case SET_CAPTCHA_KEY:
            return action.payload;
        default:
            return state;
    }
};

export const captchaImg = (state = '', action) => {
    switch (action.type) {
        case SET_CAPTCHA_IMG:
            return action.payload;
        default:
            return state;
    }
};
